import React from 'react';
import { PackageIcon } from 'lucide-react';
import { manuals } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Manuals() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:py-20" data-id="element-187" data-mp="sy7oce611urm">
      <div className="mx-auto max-w-3xl" data-id="element-188" data-mp="o3k6gy5j3ym0">
        <p className="flex items-center justify-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.25em] text-spark-500" data-id="element-189" data-mp="j61vl27yb9bd">
          <PackageIcon className="h-4 w-4" aria-hidden="true" data-id="element-190" data-mp="e80cwieftc0f" />
          Tout ce qui est inclus
        </p>
        <h2 className="mt-3 text-center font-display text-4xl font-bold uppercase leading-tight text-white sm:text-5xl" data-id="element-191" data-mp="972wobczms1k">
          Les 6 Manuels Maîtres
        </h2>

        <div className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-192" data-mp="7fwttzwpuam">
          {manuals.map(m => <article key={m.number} className="flex gap-4 rounded-2xl border border-white/10 bg-ink-800/70 p-5" data-id="element-193" data-mp="1zk0g2auejl0y">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-spark-500 font-display text-xl font-bold text-ink-950" data-id="element-194" data-mp="1ulqmg4obsshg">
                {m.number}
              </span>
              <div className="min-w-0" data-id="element-195" data-mp="1hkwkw7ry1yke">
                <h3 className="text-base font-extrabold leading-tight text-arc-400" data-id="element-196" data-mp="13k3mvd2folcj">
                  {m.title}
                </h3>
                <p className="mt-1.5 text-sm leading-snug text-white/65" data-id="element-197" data-mp="18jyddfiar8x2">{m.description}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-198" data-mp="20a355z8dyy8b">
          <CtaBlock label="Je veux les 6 manuels" data-id="element-199" data-mp="2091j6zpu0rbt" />
        </div>
      </div>
    </section>;
}